import React, { useEffect } from "react";
import { withMonogramContext } from "./MonogramContext";
import MonogramPhoto from "./MonogramPhoto";
import MonogramSideBar from "./MonogramSideBar";
import MonogramHeader from "./MonogramHeader";
import clsx from "clsx";
import { Modal } from "./Modal";
import { OVERLAYS } from "./const";

const Monogram = ({
  open,
  setOpen,
  logo,
  overlay,
  handleCloseAttempt,
  showLoginModal,
  setShowLoginModal,
}) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [open]);

  useEffect(() => {
    const openMonogramHandler = () => setOpen(true);
    const closeMonogramHandler = () => setOpen(false);
    window.addEventListener("openMonogram", openMonogramHandler);
    window.addEventListener("closeMonogram", closeMonogramHandler);
    return () => {
      window.removeEventListener("openMonogram", openMonogramHandler);
      window.removeEventListener("closeMonogram", closeMonogramHandler);
    };
  }, []);

  return (
    <>
      <div
        className={clsx("monogram__container", {
          open,
          "monogram__container--exit-intent": overlay === OVERLAYS.Exit,
        })}
      >
        <MonogramHeader overlay={overlay} mobileOnly handleCloseAttempt={handleCloseAttempt} />
        <MonogramPhoto />
        <MonogramSideBar />
      </div>
      <Modal
        visible={showLoginModal}
        setVisible={() => {
          setShowLoginModal(false);
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h4 style={{ color: "#c73676" }}>You must be logged in to Customize</h4>
          <p style={{ lineHeight: "1.4", margin: "0 0 15px 0", padding: 0 }}>
            You must be logged in to continue customize a pre-order product. Click{" "}
            <a target="_blank" rel="noopener noreferrer" href="/account/login">
              Here
            </a>{" "}
            to login. Once logged in, you can refresh this page to continue.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default withMonogramContext(Monogram);
